module.exports = __webpack_public_path__ + "img/160019.3a9586fb.png";